import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { AreaRenderer } from 'timeSheet/components/CellRenderers';

const useShiftAreaColumn = ({ mappedLocations }) => {
  const { t } = useContext(ConfigContext);

  const valueGetter = useCallback((params) => mappedLocations?.[params.data?.locationId]?.name || '', [
    mappedLocations
  ]);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;

      return AreaRenderer({
        rowData: params.data,
        columnData: { mappedLocations }
      });
    },
    [mappedLocations]
  );

  return useMemo(
    () => ({
      field: 'locationId',
      headerName: t('shiftArea'),
      cellClass: 'justify-start',
      width: 350,
      valueGetter,
      cellRenderer
    }),
    [t, valueGetter, cellRenderer]
  );
};

export default useShiftAreaColumn;
